export default "__VITE_ASSET___yP3t2NR__"